import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import {SnotifyService} from "ng-snotify";
import {CredenciamentoAplicativoService} from "../../../../services/credenciamento/aplicativo/credenciamento-aplicativo.service";
import {EmpresaService} from "../../../../services/empresa/empresa.service";

@Component({
  selector: 'app-credenciamento-aplicativo-cadastro',
  templateUrl: './novo-cadastro.component.html',
  styleUrls: ['./novo-cadastro.component.scss']
})
export class NovoCadastroComponent implements OnInit {

  public open: boolean = false

  public submitted: boolean = false

  public formGroup: FormGroup;

  public formGroupEdit: FormGroup;

  public load: boolean = false

  public lastClientCreate = null

  public empresas: Array<any> = [];

  public dropdownSettingsEmpresas = {
      singleSelection: false,
      idField: 'id_empresa',
      textField: 'descricao',
      itemsShowLimit: 5,
      selectAllText: 'Marcar todas',
      unSelectAllText: 'Desmarcar todas',
      allowSearchFilter: true
  };

  @Output('novoCadastro') novoCadastro: EventEmitter<any> = new EventEmitter<any>();

  public edit: boolean = false

  public clientEdit = null

  constructor(
    private notify: SnotifyService,
    private credeciamentoService: CredenciamentoAplicativoService,
    private empresaService: EmpresaService,
    private fb: FormBuilder,
  ) {
    this._initForms()
  }

  ngOnInit() {
      this._listarEmpresas();
  }

  openModal() {
      this.open = true
      this.submitted = false;
  }

  closeModal() {
    this.open = false
    this.submitted = false;
    this.lastClientCreate = null
    this.edit = false
  }

  submit() {
      this.edit ? this.update() : this.create()
  }

  private _listarEmpresas(): void  {
      this.empresaService.listar(null, '', 'todos')
          .subscribe(
              ({data}) => {
                  this.empresas = data.empresas.map(empresa => {
                      return {
                          id_empresa: empresa.id_empresa,
                          descricao: `${empresa.nome} - ${empresa.cpf_cnpj}`
                      };
                  });
              },
              error => {
                  this.notify.warning('Ocorreu um erro ao carregar empresas');
              }
          );
  }

  public create(): void {
      this.submitted = true
      if(this.formGroup.valid){
          let data = this.formGroup.value
          data.empresa_id = (Array.isArray(data.empresa_id) ? data.empresa_id : []).map(item => {
              return typeof item == "object" ? item.id_empresa : item
          })
          this.load = true
          this.credeciamentoService.cadastrar(data).subscribe(
              (response) => {
                  this.load = false
                  this.notify.success("Aplicativo cadastrado com sucesso!")
                  this.lastClientCreate = response.data.cliente
                  this.novoCadastro.emit(true)
                  this.reset()
              },
              (error) => {
                  this.load = false
                  console.error(error)
                  this.notify.error("Erro ao cadastrar aplicativo!")
              }
          )
      }
  }

  public update(): void {
      this.submitted = true
      if(this.formGroupEdit.valid){
          let data = this.formGroupEdit.value
          data.empresa_id = (Array.isArray(data.empresa_id) ? data.empresa_id : []).map(item => {
              return typeof item == "object" ? item.id_empresa : item
          })
          this.load = true
          this.credeciamentoService.atualizar(this.clientEdit.id, data).subscribe(
              (response) => {
                  this.load = false
                  this.notify.success("Aplicativo atualizado com sucesso!")
                  this.novoCadastro.emit(true)
              },
              (error) => {
                  this.load = false
                  console.error(error)
                  this.notify.error("Erro ao atualizar aplicativo!")
              }
          )
      }
  }

  private reset(): void {
    this.formGroup.reset()
  }

  newClient() {
      this.lastClientCreate = null
  }

  private _initForms(): void {
      this.formGroup = this.fb.group({
          name: new FormControl('', [Validators.required, Validators.maxLength(50)]),
          empresa_id: new FormControl('', [])
      })
      this.formGroupEdit = this.fb.group({
          name: new FormControl('', [Validators.required, Validators.maxLength(50)]),
          revoked: new FormControl(false, [Validators.required,]),
          secret: new FormControl({value: '', disabled: true}, [Validators.required,]),
          empresa_id: new FormControl('', []),
          id: new FormControl({value: '', disabled: true}, [Validators.required,]),
      })
  }

  public editClient(client: any): void {
      this.openModal()
      this.edit = true
      this.clientEdit = client
      this.formGroupEdit.patchValue(client)
      this.formGroupEdit.controls.empresa_id.setValue(client.empresas.map(empresa => {
          return {
              id_empresa: empresa.id_empresa,
              descricao: `${empresa.nome} - ${empresa.cpf_cnpj}`
          }
      }))
  }

  title() {
      if(this.edit){
          return 'Atualizar cadastro'
      }else if(this.lastClientCreate !== null) {
          return 'Novo Aplicativo Cadastrado'
      }else {
          return 'Cadastrar Novo Aplicativo'
      }
  }
}
